import React from 'react';
import PropTypes from 'prop-types';

const ChevronDown = ({color = 'currentColor', ...props}) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.833008 1.33334L5.00035 5.15001L9.16634 1.33334"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

ChevronDown.propTypes = {
  color: PropTypes.string,
};

export default ChevronDown;
